import React from 'react';
import classNames from 'classnames';

type Props = {
  hasLoaded: boolean,
  isOpen: boolean,
  renderHeader: Function,
  renderBody: Function,
};

function Accordion(props: Props) {
  const { isOpen, hasLoaded, renderHeader, renderBody } = props;
  const bodyClass = classNames({
    'order-history': true,
    'order-history--open': isOpen,
  });
  return (
    <div className="col__12-12 u__border--bottom-but-last u--paddingNone">
      {renderHeader(hasLoaded)}
      <div className={bodyClass}>{isOpen && renderBody()}</div>
    </div>
  );
}

export default Accordion;
